import HomeTemplate from '../templates/HomeTemplate.jsx'
import { PAGES } from '../utils/seo.js'
import { useLanguage } from '../context/LanguageContext.jsx'
import { useEffect, useState } from 'react'

const { title, description, canonical } = PAGES.home

export default function Home() {
  const { t } = useLanguage()
  const [cms, setCms] = useState(null)
  useEffect(() => {
    fetch('/admin/api/public/content').then(r => r.ok ? r.json() : null).then(setCms).catch(() => {})
  }, [])
  const hero = cms?.homepage
  return (
    <HomeTemplate
      provider="generic"
      title={title}
      description={description}
      canonical={canonical}
       badge={t('homeBadge')}
      heading={
        <>
           {hero?.heroTitle || <>{t('homeH1')}{' '}<span className="text-gradient">{t('homeH2')}</span></>}
        </>
      }
       subheading={hero?.heroDescription || t('homeSub')}
      placeholder={t('genericPlaceholder')}
       cta={hero?.cta}
    />
  )
}
